import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40",
  class: "user-badge-verification_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.667 10A8.333 8.333 0 1 1 10 10a8.333 8.333 0 0 1 16.667 0ZM1.667 28.972c0-1.344.717-2.59 1.89-3.281a29.096 29.096 0 0 1 16.624-3.967 11.62 11.62 0 0 0-2.68 7.442c0 2.125.567 4.117 1.56 5.833H4.523c-1.578 0-2.856-1.257-2.856-2.808v-3.219Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M29.772 20.276a.8.8 0 0 0-1.21 0l-1.001 1.16a.8.8 0 0 1-.868.233l-1.447-.504a.8.8 0 0 0-1.048.605l-.287 1.505a.8.8 0 0 1-.635.635l-1.505.287a.8.8 0 0 0-.605 1.048l.504 1.447a.8.8 0 0 1-.233.868l-1.16 1.001a.8.8 0 0 0 0 1.21l1.16 1.001a.8.8 0 0 1 .233.868l-.504 1.447a.8.8 0 0 0 .605 1.048l1.505.287a.8.8 0 0 1 .635.635l.287 1.505a.8.8 0 0 0 1.048.605l1.447-.504a.8.8 0 0 1 .868.233l1 1.16a.8.8 0 0 0 1.21 0l1.002-1.16a.799.799 0 0 1 .868-.233l1.447.504a.8.8 0 0 0 1.047-.605l.288-1.505a.8.8 0 0 1 .635-.635l1.505-.287a.8.8 0 0 0 .605-1.048l-.504-1.447a.8.8 0 0 1 .233-.868l1.16-1a.8.8 0 0 0 0-1.211l-1.16-1.001a.8.8 0 0 1-.233-.868l.504-1.447a.8.8 0 0 0-.605-1.048l-1.505-.287a.8.8 0 0 1-.636-.635l-.286-1.505a.8.8 0 0 0-1.048-.605l-1.447.504a.8.8 0 0 1-.868-.233l-1.001-1.16Zm4.395 6.39-1.25-1.25-5 5-2.5-2.5-1.25 1.25 3.75 3.75 6.25-6.25Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }